// Gallery Carousels
const gallerySliders = document.querySelectorAll('.js-slider--gallery'),
    gallerySliderNav = document.querySelectorAll('.js-slider-nav--gallery'),
    gallerySliderNavNext = document.querySelectorAll('.js-next-slide--gallery'),
    gallerySliderNavPrev = document.querySelectorAll('.js-prev-slide--gallery'),
    gallerySliderPagination = document.querySelectorAll('.js-pagination--gallery');

gallerySliders.forEach((el, i) => {
    const slider = new Swiper(el, {
        containerModifierClass: 'slider',
        wrapperClass: 'slider__wrapper',
        slideClass: 'slide',
        slideActiveClass: 'slide--active',
        slideVisibleClass: 'slide--visible',
        slidesPerView: 'auto',
        loop: true,
        loopedSlides: 2,
        spaceBetween: 0,
        centeredSlides: true,
        watchSlidesVisibility: true,
        watchOverflow: true,
        uniqueNavElements: true,
        initialSlide: 0,
        navigation: {
            nextEl: gallerySliderNavNext[i],
            prevEl: gallerySliderNavPrev[i],
            disabledClass: 'slider__button--disabled'
        },
        pagination: {
            el: gallerySliderPagination[i],
            type: 'bullets',
            clickable: true
        },
        keyboard: {
            enabled: true,
            onlyInViewport: true
        }
    });
});

// Team Carousels
const teamSliders = document.querySelectorAll('.js-slider--team'),
    teamSliderNav = document.querySelectorAll('.js-slider-nav--team'),
    teamSliderNavNext = document.querySelectorAll('.js-next-slide--team'),
    teamSliderNavPrev = document.querySelectorAll('.js-prev-slide--team'),
    teamSliderPagination = document.querySelectorAll('.js-pagination--team');

teamSliders.forEach((el, i) => {
    const slider = new Swiper(el, {
        containerModifierClass: 'slider',
        wrapperClass: 'slider__wrapper',
        slideClass: 'slide',
        slideActiveClass: 'slide--active',
        slideVisibleClass: 'slide--visible',
        slidesPerView: 'auto',
        spaceBetween: 0,
        watchOverflow: true,
        uniqueNavElements: true,
        initialSlide: 0,
        navigation: {
            nextEl: teamSliderNavNext[i],
            prevEl: teamSliderNavPrev[i],
            disabledClass: 'slider__button--disabled'
        },
        pagination: {
            el: teamSliderPagination[i],
            type: 'bullets',
            clickable: true
        },
        keyboard: {
            enabled: true,
            onlyInViewport: true
        }
    });
});


// Testimonial Carousels
const testimonialsSliders = document.querySelectorAll('.js-slider--testimonials'),
    testimonialsSliderNav = document.querySelectorAll('.js-slider-nav--testimonials'),
    testimonialsSliderNavNext = document.querySelectorAll('.js-next-slide--testimonials'),
    testimonialsSliderNavPrev = document.querySelectorAll('.js-prev-slide--testimonials'),
    testimonialsSliderPagination = document.querySelectorAll('.js-pagination--testimonials'),
    swiperInstances = [],
    delay = 250;

let throttled = false;

function handleTestimonialSliders() {    
    testimonialsSliders.forEach((el, i) => {
        if (window.innerWidth < 768) {
            swiperInstances.push(new Swiper(el, {
                containerModifierClass: 'slider',
                wrapperClass: 'slider__wrapper',
                slideClass: 'slide',
                slideActiveClass: 'slide--active',
                slideVisibleClass: 'slide--visible',
                slidesPerView: 'auto',
                spaceBetween: 0,
                watchOverflow: true,
                uniqueNavElements: true,
                initialSlide: 0,
                navigation: {
                    nextEl: testimonialsSliderNavNext[i],
                    prevEl: testimonialsSliderNavPrev[i],
                    disabledClass: 'slider__button--disabled'
                },
                pagination: {
                    el: testimonialsSliderPagination[i],
                    type: 'bullets',
                    clickable: true
                },
                keyboard: {
                    enabled: true,
                    onlyInViewport: true
                },
                keyboard: {
                    enabled: true,
                    onlyInViewport: true
                }
            }));
        } else {
            // Destroy any swiper instances
            swiperInstances.forEach(swiper => {
                swiper.destroy(true, true);
            });
        }
    });
}

// window.resize event listener
window.addEventListener('resize', function() {
    // Only run if we're not throttled
    if (!throttled) {
        handleTestimonialSliders();

        throttled = true;

        // Set a timeout to un-throttle
        setTimeout(function() {
            throttled = false;
        }, delay);
    }  
});

handleTestimonialSliders();